import classes from './Tag.module.css.mjs';

const tagVariantClasses = {
  default: classes.tagVariantDefault,
  discontinued: classes.tagVariantDiscontinued,
  filled: classes.tagVariantFilled
};

export { tagVariantClasses };
